import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { IBaseLayer } from 'shared/interfaces';
import { Project } from '../../classes';
import { AppService, ProjectService } from '../../services';

@Component({
  selector: 'geo-project-list',
  templateUrl: 'app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent implements OnInit {
  @ViewChild('modal') modal: ModalDirective;

  filter = '';
  modalHeader = 'НОВЫЙ ПРОЕКТ';
  baseMaps: IBaseLayer[] = [];
  projects: Project[];
  currentProject: Project;
  canAdd = false;
  submitBtnText = 'Создать проект';

  private data: Project[];
  private project_id: number;

  constructor(private projectsService: ProjectService, private appService: AppService, private el: ElementRef) {}

  ngOnInit() {
    // TODO: добавить проверку на IE11, использовать URL API
    this.project_id = Number(this.getParameterByName('project_id', window.location.href));
    this.getProjects();
    this.getBaseMaps();
  }

  refresh() {
    this.getProjects();
    this.currentProject = null;
    this.modal.hide();
  }

  filterByName(value: string) {
    const trimmedValue = value.trim().toLowerCase();
    this.projects = this.data.filter(
      project =>
        project.name
          .trim()
          .toLowerCase()
          .indexOf(trimmedValue) !== -1
    );
  }

  editProject(project: Project) {
    if (project) {
      this.setModal(`НАСТРОЙКИ ПРОЕКТА ${project.name}`, 'Сохранить');
      this.currentProject = project;
    } else {
      this.setModal('НОВЫЙ ПРОЕКТ', 'Создать проект');
      this.currentProject = new Project({ base_map: this.baseMaps.length ? this.baseMaps[0] : null });
    }
  }

  clearFilter() {
    this.filter = '';
    this.projects = this.data;
  }

  deleteProject(project: Project) {
    if (confirm(`Удалить проект ${project.name} и все связанные с ним слои?`)) {
      this.projectsService.deleteProject(project).subscribe(() => {
        this.getProjects();
      });
    }
  }

  private getBaseMaps() {
    this.appService.getBasemaps().subscribe(data => {
      this.baseMaps = data;
    });
  }

  private getProjects() {
    this.projectsService.getProjects().subscribe(data => {
      this.data = data.projects;
      this.projects = this.data;
      this.canAdd = data.can_add;

      // Если перешли со страницы проекта на редактирование,
      // открываем модальное окно
      let project;
      if (this.project_id) {
        project = this.projects.find(item => item.id.toString() === this.project_id.toString());
      }

      const userCanEdit: string = this.el.nativeElement.getAttribute('canEdit');

      if (project && userCanEdit === 'True') {
        this.editProject(project);
        this.project_id = null;
      }
    });
  }

  private setModal(title: string, btnText: string) {
    this.modal.show();
    this.modalHeader = title;
    this.submitBtnText = btnText;
  }

  private getParameterByName(name: string, url: string): string {
    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) {
      return null;
    }
    if (!results[2]) {
      return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
}
